import classNames from 'classnames';

import './tag.scss';
import type { TagProps } from './types';

export const Tag = ({ className, children, variant = 'default', shape = 'default' }: TagProps) => (
  <div className={classNames('payflow-ui payflow-ui-tag', `tag-${variant}`, `tag-shape-${shape}`, className)}>
    {children}
  </div>
);
